import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {fetchData} from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import {Card, DataTable} from '../UI';

const columns = [
    {
        name: 'Role',
        selector: 'name',
        cell: (row) => <Link to={`/roles/${row.name}`}>{row.name}</Link>,
    },
    {
        name: 'Permissions',
        selector: (row) => row.permissions.length,
        sortable: true,
    },
];

export default function RolesListing() {
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData(Endpoints.LIST_ROLES)
            .then((res) => res.json())
            .then((res) => {
                setRoles(res.roles || []);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, []);

    return (
        <PageLayout title="Roles">
            <Card padded={false}>
                <DataTable
                    columns={columns}
                    data={roles}
                    progressPending={loading}
                    noHeader={true}
                />
            </Card>
        </PageLayout>
    );
}
